import { useState, type FormEvent } from 'react';
import { RatingInput } from './RatingInput';
import { t } from '../i18n';

export interface DrinkSubmission {
  rating?: number;
  notes?: string;
}

/**
 * The form opened by "Boire une bouteille" (FR-012 as changed by the owner on 2026-09-28): an
 * optional rating and an optional comment. Nothing is recorded, and the stock does not move, until
 * the person taps "Valider"; "Annuler" closes it with no change. It never closes by itself.
 */
export function DrinkForm({
  id,
  onConfirm,
  onCancel,
}: {
  /** Unique per form on the page, for the fields' labels. */
  id: string;
  onConfirm: (value: DrinkSubmission) => void;
  onCancel: () => void;
}) {
  const [rating, setRating] = useState('');
  const [notes, setNotes] = useState('');

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    onConfirm({
      ...(rating !== '' ? { rating: Number(rating) } : {}),
      ...(notes.trim() !== '' ? { notes: notes.trim() } : {}),
    });
  }

  return (
    <form className="drink-form" onSubmit={handleSubmit} aria-label={t('drink.title')}>
      <p className="drink-form__title">{t('drink.title')}</p>
      <RatingInput
        id={`${id}-rating`}
        label={t('drink.rating')}
        value={rating}
        onChange={setRating}
      />
      <label htmlFor={`${id}-notes`}>{t('drink.notes')}</label>
      <textarea
        id={`${id}-notes`}
        rows={2}
        value={notes}
        onChange={(event) => setNotes(event.target.value)}
      />
      <div className="drink-form__actions">
        <button type="button" onClick={onCancel}>
          {t('common.cancel')}
        </button>
        <button type="submit" className="drink-form__confirm">
          {t('drink.confirm')}
        </button>
      </div>
    </form>
  );
}
